module.exports = __webpack_public_path__ + "static/media/10.dc193bf5.jpg";